/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamItemSubTypes200,
  GetApiV1ExamItemSubTypes400,
  GetApiV1ExamItemSubTypes401,
  GetApiV1ExamItemSubTypes500,
  GetApiV1ExamItemSubTypesQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamItemSubTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamItemSubTypes200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamItemSubTypes200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamItemSubTypes400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemSubTypes400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamItemSubTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemSubTypes401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamItemSubTypes500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemSubTypes500>;

export const getApiV1ExamItemSubTypesQueryResponseSchema = z.lazy(
  () => getApiV1ExamItemSubTypes200Schema,
) as unknown as ToZod<GetApiV1ExamItemSubTypesQueryResponse>;
